import React, { FunctionComponent } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { RestfulProvider } from 'restful-react'
import BrowserNotSupported from './Components/BrowserNotSupported'
import StepperContainer from './Components/StepperContainer'

export interface AppProps {
  isCompatible: boolean
  nameBrowser: string
}

const App: FunctionComponent<AppProps> = ({ isCompatible, nameBrowser }) => {
  let CHATBRIDGE_URL = (window as any).ChatroomConfig?.ChatbridgeBaseUrl ?? ''

  if (CHATBRIDGE_URL === '#{ChatbridgeBaseUrl}#') {
    CHATBRIDGE_URL = 'http://localhost:7071'
  }

  return !isCompatible ? (
    <BrowserNotSupported nameBrowser={nameBrowser} />
  ) : (
    <RestfulProvider base={CHATBRIDGE_URL}>
      <Router>
        <Switch>
          <Route path='/'>
            <StepperContainer />
          </Route>
        </Switch>
      </Router>
    </RestfulProvider>
  )
}

export default App
